import Page from "./Package";

export default Page;
